/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export class SharedPrefConstants {
    public static BOOKMARK_ACTION_PREF_KEY = 'bookmarkAction';

    public static BOOKMARK_ACTION_KERNEL_TYPE = 'bookmarkActionKernel';

    public static BOOKMARK_CONTENT_ID = 'bookmarkContentId';

    public static BOOKMARK_COLLECTION_ID = 'bookmarkCollectionId';

    public static CANCEL_ONE_PASS_ACTION = 'cancelOnePassAction';

    public static CREATE_ONE_PASS_ACTION = 'createOnePassAction';

    public static COLLECTION_BROWSE_STICKINESS_INFO = 'collectionBrowseStickiness';

    public static COLLECTION_BROWSE_STICKINESS_PREF_KEY = 'collectionBrowseStickinessKey';

    public static COLLECTION_FILTERS_INFO = 'collectionFiltersList';

    public static COLLECTION_FILTERS_PREF_KEY = 'collectionFilters';

    public static COLLECTION_INFO = 'collectionInfo';

    public static COLLECTION_INFO_PREF_KEY = 'collectionInfoKey';

    public static COLLECTION_UPCOMING_FILTER_INFO = 'collectionUpcomingFilterInfo';

    public static COLLECTION_ONE_PASS_ACTION_LIST = 'collectionOnePassActionList';

    public static COLLECTION_ONE_PASS_ACTION_PREF_KEY = 'collectionOnePassAction';

    public static COLLECTION_PREVIEW = 'collectionPreview';

    public static COLLECTION_WATCH_ACTIONS = 'collectionWatchActions';

    public static DISK_SPACE_PERCENTAGE_USED = 'diskSpacePercentageUsed';

    public static DISK_SPACE_PREF_KEY = 'diskSpace';

    public static MODIFY_ONE_PASS_ACTION = 'modifyOnePassAction';

    public static ONE_PASS_ACTION_PREF_KEY = 'onePassAction';

    public static ONE_PASS_USER_SELECTED_OPTIONS = 'onePassUserSelectedOptions';

    public static PLAY_RECORDING_PREF_KEY = 'playRecording';

    public static PLAY_RECORDING_ACTION = 'playRecordingAction';

    public static PROGRAM_SCREEN_PREF_KEY = 'programScreen';

    public static PROGRAM_INFO = 'programInfo';

    public static PROGRAM_SCREEN_HORIZONTAL_OPTIONS = 'programScreenHorizontalOptions';

    public static PROGRAM_SCREEN_TITLE = 'programScreenTitle';

    public static RECORDING_ACTION_PREF_KEY = 'recordingAction';

    public static RECORDING_CANCEL_ACTION_ID = 'recordingCancelActionId';

    public static RECORDING_GUIDECELL_INFO = 'recordingGuidecellInfo';

    public static RECORDING_ACTION_KERNEL_TYPE = 'recordingActionKernelType';

    public static RECORDING_USER_SELECTED_OPTIONS = 'recordingUserSelectedOptions';

    public static RECORDING_ACTION_KERNEL = 'recordingActionKernel';

    public static RECORDING_CONTENT_ID = 'recordingContentId';

    public static RECORDING_OFFER_ID = 'recordingOfferId';

    public static SELECTED_ONE_PASS_UCID = 'selectedOnePassUCId';
}
